@if (routerUrl) {
  <a [routerLink]="[routerUrl]" class="re-bg-white re-w-full re-h-full re-flex re-items-center re-group">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
} @else {
  <a [href]="href" [target]="openInNewTab ? '_blank' : '_self'" class="re-bg-white re-w-full re-h-full re-flex re-items-center re-group">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
}


<ng-template #content>
  <div class="re-w-full re-px-20 lg:re-px-30">
    <div class="re-flex re-justify-between re-items-center">
      <h5 class="re-self-center re-inline-block">{{linkText}}</h5>
      <div class="arrow-icon re-ml-15 re-flex-shrink-0 group-hover:re-text-primary re-w-25 re-h-25">
        <svg-icon class="re-block" [src]="'assets/icons/arrow-right.svg'"></svg-icon>
      </div>
    </div>
  </div>
</ng-template>
